var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-skeleton',_vm._g(_vm._b({attrs:{"animated":""}},'el-skeleton',_vm.$attrs,false),_vm.$listeners),[_c('template',{slot:"template"},[_c('div',[_c('el-skeleton-item',{style:({ width: _vm.width, height: _vm.height }),attrs:{"variant":"rect"}})],1)]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }